<template>
  <div class="modal fade" :id="modalId" tabindex="-1" data-bs-backdrop="static" style="z-index: 1075">
    <div class="modal-dialog">
      <div class="modal-content">

        <div class="modal-header">
          <h5 class="modal-title">{{ isEditing ? $t('button.edit') : $t('destockage.new_external_driver') }}</h5>
          <div class="modal-icon-close-btn ms-2" data-bs-dismiss="modal" aria-label="Close">
            <span class="svg-icon svg-icon-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor"/>
                <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor"/>
              </svg>
            </span>
          </div>
        </div>

        <div class="modal-body">
          <form @submit.prevent="submit">

            <div class="d-flex flex-column mb-6 fv-row">
              <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                <span class="required">{{ $t('destockage.external_driver_name') }}</span>
              </label>
              <input
                type="text"
                required
                class="form-control form-control-solid"
                v-model="form.name"
                :placeholder="$t('destockage.external_driver_name')"
              />
            </div>

            <InputTel
              :name="`${modalId}-phone`"
              :label="$t('destockage.external_driver_phone')"
              containerClass="mb-6"
              labelClass="fs-6 fw-bold mb-2"
              inputClass="form-control form-control-sm form-control-solid"
              v-model:phone="form.phone"
              v-model:phone-code="form.phone_code"
              :placeholder="$t('enter_phone')"
              :isRequired="false"
            />

            <div class="modal-footer px-0 pb-0">
              <button type="button" class="btn btn-sm btn-light btn-light-close" data-bs-dismiss="modal">
                {{ $t('button.close') }}
              </button>
              <button type="submit" class="btn btn-sm btn-primary fw-bolder" :disabled="isLoading">
                <span class="indicator-label">{{ $t('button.save') }}</span>
                <span v-if="isLoading" class="spinner-border spinner-border-sm align-middle ms-2"></span>
              </button>
            </div>

          </form>
        </div>

      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import InputTel from '@/components/InputTel.vue'
import i18n from '@/plugins/i18n'

const props = defineProps({
  modalId: {
    type: String,
    default: 'createExternalDeliveryPersonModal',
  },
})

const emit = defineEmits(['person-saved'])

const store = useStore()
const isLoading = ref(false)

const emptyForm = () => ({
  id: null,
  name: '',
  phone: '',
  phone_code: '',
})

const form = ref(emptyForm())
const isEditing = computed(() => !!form.value.id)

function open() {
  form.value = emptyForm()
  $(`#${props.modalId}`).modal('show')
}

function openForEdit(person) {
  form.value = {
    id: person.id,
    name: person.name,
    phone: person.phone || '',
    phone_code: person.phone_code || '',
  }
  $(`#${props.modalId}`).modal('show')
}

function close() {
  $(`#${props.modalId}`).modal('hide')
}

async function submit() {
  isLoading.value = true
  try {
    const action = isEditing.value ? 'ecommerce/updateExternalDeliveryPerson' : 'ecommerce/createExternalDeliveryPerson'
    const response = await store.dispatch(action, form.value)
    const person = response?.data?.delivery_person
    if (person) {
      window.toastr['success'](i18n.global.t(isEditing.value ? 'destockage.external_driver_updated' : 'destockage.external_driver_created'))
      emit('person-saved', { person, isEditing: isEditing.value })
      form.value = emptyForm()
      close()
    }
  } catch {
    // géré par l'intercepteur axios global (affiche le message serveur, ex: doublon)
  } finally {
    isLoading.value = false
  }
}

defineExpose({ open, openForEdit, close })
</script>
